import { Routes, Route, Navigate } from 'react-router-dom'
import { AppContainer } from '@templatean/shared/components'
import { useAuth } from '@templatean/shared/hooks'
import LoginPage from './pages/LoginPage'
import HomePage from './pages/HomePage'
import PresentationBuilderPage from './pages/PresentationBuilderPage'
import SlideTemplatesPage from './pages/SlideTemplatesPage'
import DesignStudioPage from './pages/DesignStudioPage'
import SettingsPage from './pages/SettingsPage'

function App() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return <AppContainer loading={true}>{null}</AppContainer>
  }

  if (!isAuthenticated) {
    return <LoginPage />
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/builder" element={<PresentationBuilderPage />} />
      <Route path="/templates" element={<SlideTemplatesPage />} />
      <Route path="/design" element={<DesignStudioPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App